import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

const variantStyles = {
  solid:
    'bg-grey-lighter data-[orientation=horizontal]:h-px data-[orientation=vertical]:w-px',
  dashed:
    'bg-transparent border-grey-lighter border-0 data-[orientation=horizontal]:border-t data-[orientation=horizontal]:h-0 data-[orientation=vertical]:border-l data-[orientation=vertical]:w-0 data-[orientation=vertical]:h-full'
};

export default function Separator({
  className,
  orientation = 'horizontal',
  variant = 'solid',
  ...props
}) {
  const isDashed = variant === 'dashed';
  return (
    <hr
      data-slot='separator'
      data-orientation={orientation}
      className={cn(
        'shrink-0 my-0! border-0',
        'data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full',
        isDashed && 'border-dashed',
        variantStyles[variant] ?? variantStyles.solid,
        className
      )}
      {...props}
    />
  );
}

Separator.propTypes = {
  className: propTypes.string,
  orientation: propTypes.oneOf(['horizontal', 'vertical']),
  variant: propTypes.oneOf(['solid', 'dashed'])
};
